<script>
    import Pages from '../../pages';
    import router from '../../router';
    import state from '../../state';

    function changePage(e, newPage) {
        e.preventDefault();

        if ($state.page === newPage.key) return;

        router.nav.navigate(newPage.path);
    }
</script>

<style>
    @media only screen and (max-width: 1024px) {
        ul.main-menu {
            margin: 30px 0;
        }

        ul.main-menu a {
            display: block;
            color: #fff;
            padding: 12px 0;
            line-height: 21px;
            opacity: .7;
        }

        ul.main-menu a.active {
            opacity: 1;
        }

        ul.main-menu .menu-icon {
            display: none;
        }

        ul.main-menu .link-text {
            font-size: 16px;
            line-height: 21px;
        }
    }

    @media only screen and (min-width: 1025px) {
        ul.main-menu {
            position: absolute;
            padding: 15px 0;
            width: 70px;
            right: -90px;
            background-color: #444;
            border-radius: 35px;
            z-index: 999;
            list-style: none;
            top: 0;
            -webkit-box-shadow: 0 0 30px -5px rgba(0, 0, 0, .15);
            -moz-box-shadow: 0 0 30px -5px rgba(0, 0, 0, .15);
            box-shadow: 0 0 30px -5px rgba(0, 0, 0, .15);
        }

        ul.main-menu a {
            display: block;
            position: relative;
            color: #b5b6b7;
            padding: 10px;
            -webkit-transition: all 0.3s ease-in-out;
            -moz-transition: all 0.3s ease-in-out;
            -o-transition: all 0.3s ease-in-out;
            -ms-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
        }

        ul.main-menu a.active,
        ul.main-menu a:focus,
        ul.main-menu a:hover {
            color: #5050f5;
        }

        ul.main-menu .menu-icon {
            display: block;
            font-size: 30px;
        }

        ul.main-menu .link-text {
            position: absolute;
            width: auto;
            visibility: hidden;
            opacity: 0;
            color: #fff;
            padding: 2px 10px;
            background-color: #5050f5;
            white-space: nowrap;
            right: 0;
            top: -50%;
            margin-top: 50%;
            -webkit-transition: all 0.3s ease-in-out;
            -moz-transition: all 0.3s ease-in-out;
            -o-transition: all 0.3s ease-in-out;
            -ms-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
            z-index: 0;
            box-shadow: 0px 10px 10px -8px rgba(0, 0, 0, .22);
        }

        ul.main-menu a:hover .link-text {
            right: 100%;
            visibility: visible;
            opacity: 1;
        }
    }
</style>

<ul class="main-menu">
    {#each Pages as page}
        <!-- svelte-ignore a11y_click_events_have_key_events -->
        <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
        <li class:active={page.key === $state.page} onclick={(e) => changePage(e, page)}>
            <a href="{page.path}" class="nav-anim" class:active={page.key === $state.page}>
                <span class="menu-icon lnr lnr-{page.icon}"></span>
                <span class="link-text">{page.menuTitle || page.title}</span>
            </a>
        </li>
    {/each}
</ul>